import request from "@/router/axios";
export const add = (row) => {
  return request({
    url: "/api/produce/station/insert",
    method: "post",
    data: row,
  });
};
export const update = (row) => {
  return request({
    url: "/api/produce/station/update",
    method: "post",
    data: row,
  });
};
export const getList = (params) => {
  return request({
    url: "/api/produce/station/select/page",
    method: "get",
    params,
  });
};
export const remove = (ids) => {
  return request({
    url: "/api/produce/station/delete/ids",
    method: "get",
    params: {
      ids,
    },
  });
};
